import React from 'react';
import AdminHeader from '../../globals/Layout/Admin/AdminHeader';
import TFactorst from './Tables/TFactorst';
const Factors: React.FC = () => {
    return (
        <div>
            <AdminHeader>Factores de transformación</AdminHeader>  
            <TFactorst/>        
        </div>

    );
};


export default Factors;